import { ACTION_TYPE } from '../../core/redux/actionType';
import { IAppState } from '../../core/redux/IAppState';
import { Action } from 'redux';
import { assoc } from '../../language/module';


/**
 * Makes an action you can dispatch to clear out the weekly visitor reports in app state.
 */
export const clearWeeklyVisitorReportsAction = () => ({
  type: ACTION_TYPE.CLEAR_WEEKLY_VISITOR_DATA_REPORTS,
});


export const clearWeeklyVisitorReportsReducer = (
  state: IAppState,
  action: Action,
): IAppState => action.type !== ACTION_TYPE.CLEAR_WEEKLY_VISITOR_DATA_REPORTS ? state : assoc('weeklyVisitorDataReports', undefined, state);